import React, {useState} from 'react';

/* A function that returns a JSX element. */
export const Factura = (props) => {
	/* Destructuring the props object. */
	const {
		key,
		fotoFactura,
		nombreCliente,
		fechaFacturacion,
		peridodoInit,
		peridoFinal,
		numeroFactura,
		tipoServicio,
		horasDias,
		precioHora,
		tipoTarjeta,
		numTarjeta,
		cargdoAdicionales,
		totalFactura,
		pagoAgencia,
		estadoPago,
		ListaFacturasSeleccionas,
		setListaFacturasSeleccionas,
	} = props;

	/* A state that is used to change the class of the div that contains the invoice. */
	const [Seleccionar, setSeleccionar] = useState('factura');

	/* A state that is used to hide or show the factura. */
	const [SeleccionFactura, setSeleccionFactura] = useState({
		visibility: 'hidden',
	});

	/**
	 * It adds the number of the invoice to the list of selected invoices.
	 */
	const añadirFacutra = () => {
		let lista = [];
		ListaFacturasSeleccionas.map((factura) => {
			return lista.push(factura);
		});
		lista.push(numeroFactura);
		setListaFacturasSeleccionas(
			lista.map((factura) => {
				return factura;
			})
		);
	};

	/**
	 * It removes a factura from the list of facturas.
	 */
	const quitarFactura = () => {
		let lista = [];
		if (Factura.length > 0) {
			ListaFacturasSeleccionas.map((factura) => {
				if (factura != numeroFactura) {
					lista.push(factura);
				}
			});
			setListaFacturasSeleccionas(lista);
		}
	};

	/**
	 * A function that is called when the user clicks on a button.
	 */
	const seleccionar = () => {
		if (Seleccionar === 'factura') {
			setSeleccionar('facturaSeleccionada');
			añadirFacutra(key);
		} else {
			setSeleccionar('factura');
			quitarFactura(key);
		}
	};

	/* Returning a JSX element. */
	return (
		<>
			<div className='contFactu'>
				{/*
                    (Seleccionar != "factura")
                        ? <div className={'seleccionDeFacutura centrador'}
                            style={SeleccionFactura}
                            onClick={seleccionar}
                        >

                            <div><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-check2-square" viewBox="0 0 16 16">
                                <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z" />
                                <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
                            </svg></div>
                        </div>
                        : null
    */}
				<div
					className={Seleccionar}
					onClick={seleccionar}
				>
					<div className='superiorFactura'>
						<div className='izqSuperiorFactura'>
							<div className='centrador fotoFactura'>
								<div className='centrador'>
									<img src={fotoFactura} />
								</div>
							</div>
							<div className='infoIzqSuperiorFactura'>
								<div className='nombreCliente'>{nombreCliente}</div>
								<div>Fecha de la facturación: {fechaFacturacion}</div>
								<div>
									Perido: {peridodoInit} - {peridoFinal}
								</div>
								<div>Número dde facturador: {numeroFactura}</div>
							</div>
						</div>
						<div className='centSuperiorFactura'>
							<div>{tipoServicio}</div>
							<div>
								{horasDias} horas * {precioHora}€/hora
							</div>
							<div>
								{tipoTarjeta} {numTarjeta}
							</div>
							<div>Cargo adicionales: {cargdoAdicionales}</div>
						</div>
						<div className='derSuperiorFactura'>
							<div className='FacturaAlCliente'>
								<p>
									{' '}
									Facturado al cliente:
									<b style={{marginRight: '1.3em'}}> {totalFactura}€</b>
								</p>
							</div>
							<div>Pagar a la agencia: {pagoAgencia}€</div>
							<div>¿Se ha pagado a la agencia? {estadoPago}</div>
						</div>
					</div>
					<div className='inferioFactura'>
						<div className='verFactura'>
							<div className='centrador iconoVerFactura'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='currentColor'
									className='bi bi-filetype-pdf'
									viewBox='0 0 16 16'
								>
									<path
										fillRule='evenodd'
										d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z'
									/>
								</svg>
							</div>
							<div>Ver factura</div>
						</div>
						<div className='actualizarMensajes'>
							<div className='actulizarFactura'>Actualizar factura</div>
							<div className='mensajePaciente'>Mensaje de Paciente</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
